import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import * as actions from './actions'
import * as constants from './constants'
import saga from './saga'
import reducer from './reducer'

export { actions, constants, reducer, saga }

export const createUserReportsNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'script',
  text: translateFn('cmd_user_reports'),
  identity: '/secure/reporting',
  permission: 'VIEW_USER_REPORTS',
}))

export default Loadable(() => import('./Reporting'))
